<div class="institution-page">
  <div class="col-12 div-padding md:col-10 md:col-offset-1">
    <div class="institution-header mb-6">
      <h2 class="page-title">
        {{ 'Header.Institution_Settings' | translate }}
      </h2>
      <div class="yellow-line"></div>

      <div class="institution-sub-page">
        <form [formGroup]="institutionSettingsForm" (ngSubmit)="onSubmit()">
          <ng-container>
            <div class="col-12">
              <div class="md:col-12 pb-0">
                <span class="label uppercase">{{ 'InstitutionSettings.Name' | translate }}</span>
              </div>
              <div class="md:col-12">
                <input pInputText formControlName="name" id="name" placeholder="" class="w-full" />
              </div>
              @if (
                  institutionSettingsForm.controls.name.invalid &&
                  (institutionSettingsForm.controls.name.dirty || institutionSettingsForm.controls.name.touched)
                ) {
<div
               >
                @if (institutionSettingsForm.controls.name.hasError('required')) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                  icon="pi pi-info-circle"
                  text="{{ 'InstitutionSettings.NameRequired' | translate }}" />
}
                @if (institutionSettingsForm.controls.name.hasError('pattern')) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                  icon="pi pi-info-circle"
                  text="{{ 'SignUp.AllowAlphaNumericDiacritics' | translate }}" />
}
              </div>
}
            </div>
            <div class="col-12">
              <div class="md:col-12 pb-0">
                <span class="label uppercase">{{ 'InstitutionSettings.Address' | translate }}</span>
              </div>
              <div class="md:col-12">
                <input pInputText formControlName="address" id="address" placeholder="" class="w-full" />
              </div>
              @if (
                  institutionSettingsForm.controls.address.invalid &&
                  (institutionSettingsForm.controls.address.dirty || institutionSettingsForm.controls.address.touched)
                ) {
<div
               >
                @if (institutionSettingsForm.controls.address.hasError('required')) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                  icon="pi pi-info-circle"
                  text="{{ 'InstitutionSettings.AddressRequired' | translate }}" />
}

                @if (institutionSettingsForm.controls.address.hasError('pattern')) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                  icon="pi pi-info-circle"
                  text="{{ 'InstitutionSettings.MaxMinCharacters' | translate }}" />
}
                @if (
                    institutionSettingsForm.controls.address.hasError(
                      'invalidAlphanumericWithSpecialCharactersAndDiacriticsInput'
                    )
                  ) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                  icon="pi pi-info-circle"
                  [text]="allowAlphaNumericDiacritics" />
}
              </div>
}
            </div>
            <div class="grid m-0">
              <div class="col-6">
                <div class="md:col-12 pb-0">
                  <span class="label uppercase">{{ 'InstitutionSettings.Country' | translate }}</span>
                </div>
                <div class="md:col-12">
                  <p-select
                    id="coutryId"
                    class="w-full"
                    formControlName="countryId"
                    [options]="(countries$ | async) ?? []"
                    optionLabel="name"
                    optionValue="id"
                    placeholder="{{ 'InstitutionSettings.Select' | translate }}"
                    (onChange)="onChangeCountry()" />
                </div>
                @if (
                    institutionSettingsForm.controls.countryId.touched &&
                    institutionSettingsForm.controls.countryId.hasError('required')
                  ) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                  icon="pi pi-info-circle"
                  text="{{ 'SignUp.CountryRequired' | translate }}" />
}
              </div>
              <div class="col-6">
                <div class="md:col-12 pb-0">
                  <span class="label uppercase">{{ 'InstitutionSettings.RegionCounty' | translate }}</span>
                </div>
                <div class="md:col-12">
                  <p-select
                    id="regionId"
                    class="w-full"
                    formControlName="regionId"
                    [options]="(regions$ | async) ?? []"
                    optionLabel="name"
                    optionValue="id"
                    placeholder="{{ 'InstitutionSettings.Select' | translate }}"
                    (onChange)="onChangeRegion()" />
                </div>
                @if (
                    institutionSettingsForm.controls.regionId.touched &&
                    institutionSettingsForm.controls.regionId.hasError('required')
                  ) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                  icon="pi pi-info-circle"
                  text="{{ 'SignUp.CountyRequired' | translate }}" />
}
              </div>
              <div class="col-6">
                <div class="md:col-12 pb-0">
                  <span class="label uppercase">{{ 'InstitutionSettings.ZipCode' | translate }}</span>
                </div>
                <div class="md:col-12">
                  <input pInputText id="zipPostalCode" formControlName="zipPostalCode" placeholder="" class="w-full" />
                </div>
                @if (
                    institutionSettingsForm.controls.zipPostalCode.invalid &&
                    (institutionSettingsForm.controls.zipPostalCode.dirty ||
                      institutionSettingsForm.controls.zipPostalCode.touched)
                  ) {
<div
                 >
                  @if (institutionSettingsForm.controls.zipPostalCode.hasError('required')) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                    icon="pi pi-info-circle"
                    text="{{ 'SignUp.ZipcodeRequired' | translate }}" />
}

                  @if (institutionSettingsForm.controls.zipPostalCode.hasError('invalidAlphanumericInput')) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                    icon="pi pi-info-circle"
                    [text]="allowAlphanumeric" />
}
                </div>
}
              </div>
              <div class="col-6">
                <div class="md:col-12 pb-0">
                  <span class="label uppercase">{{ 'InstitutionSettings.City' | translate }}</span>
                </div>
                <div class="md:col-12">
                  <p-select
                    id="cityId"
                    class="w-full"
                    formControlName="cityId"
                    [options]="(cities$ | async) ?? []"
                    [filter]="true"
                    filterBy="name"
                    [showClear]="false"
                    optionLabel="name"
                    optionValue="id"
                    placeholder="{{ 'InstitutionSettings.Select' | translate }}" />
                </div>
                @if (
                    institutionSettingsForm.controls.cityId.touched &&
                    institutionSettingsForm.controls.cityId.hasError('required')
                  ) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                  icon="pi pi-info-circle"
                  text="{{ 'SignUp.CityRequired' | translate }}" />
}
              </div>
            </div>
            <div class="col-12">
              <div class="md:col-12 pb-0">
                <span class="label uppercase">{{ 'InstitutionSettings.InstitutionId' | translate }}</span>
              </div>
              <div class="md:col-12">
                <input
                  pInputText
                  readonly
                  id="institutionId"
                  formControlName="institutionId"
                  placeholder=""
                  class="w-full" />
              </div>
            </div>
            <div class="col-12">
              <div class="md:col-12 pb-0">
                <span class="label uppercase">{{ 'InstitutionSettings.ContractNumber' | translate }}</span>
              </div>
              <div class="md:col-12">
                <input pInputText readonly id="contractNo" formControlName="contractNo" placeholder="" class="w-full" />
              </div>
            </div>
            <div class="">
              <p-button label="{{ 'InstitutionSettings.SaveSettings' | translate }}"
                styleClass="p-button-rounded mx-auto"
                type="submit"
                [disabled]="!institutionSettingsForm.valid" />
            </div>
          </ng-container>
        </form>
      </div>
    </div>
  </div>
</div>
